export const orderList = (dispatch, apiClient, filters, limit = 50, from = null) => {
  dispatch({ type: 'ORDER_PENDING' });
  return apiClient
    .call({
      endpoint: 'order/list',
      data: { filters, limit, from }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'ORDER_LIST', data: res.data });
      return res;
    })
    .catch(e => {
      dispatch({ type: 'ORDER_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get order list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const orderRefresh = (dispatch, apiClient, OrderId) => {
  return apiClient
    .call({
      endpoint: 'order/refreshOrder',
      data: { OrderId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't refresh order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const orderRefreshByInvoiceId = (dispatch, apiClient, InvoiceId) => {
  return apiClient
    .call({
      endpoint: 'order/refreshOrderByInvoiceId',
      data: { InvoiceId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't refresh order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const pickItem = (
  dispatch,
  apiClient,
  orderId,
  boxId,
  itemId,
  mode,
  override,
  negative
) => {
  return apiClient
    .call({
      endpoint: 'order/pickItem',
      data: { orderId, boxId, itemId, mode, override, negative }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't refresh order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const boxResetStatus = (dispatch, apiClient, orderId, boxId) => {
  return apiClient
    .call({
      endpoint: 'order/resetBoxStatus',
      data: { orderId, boxId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't update order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const boxReset = (dispatch, apiClient, orderId, boxId, state) => {
  return apiClient
    .call({
      endpoint: 'order/reset',
      data: { orderId, boxId, state }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't update order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const orderByStatus = (dispatch, apiClient, tabName, from, filters = null) => {
  dispatch({ type: 'ORDER_PENDING' });
  return apiClient
    .call({
      endpoint: 'order/listByStatus',
      data: { tabName, from, filters }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'ORDER_LIST_TABNAME', data: res.data, from });
      return res;
    })
    .catch(e => {
      dispatch({ type: 'ORDER_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get order list",
        snackType: 'warning'
      });
      throw e;
    });
};
export const search = (dispatch, apiClient, seek, from) => {
  dispatch({ type: 'ORDER_PENDING' });
  return apiClient
    .call({
      endpoint: 'order/search',
      data: { seek, from }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'ORDER_LIST_TABNAME', data: res.data });
      return res;
    })
    .catch(e => {
      dispatch({ type: 'ORDER_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't search for orders",
        snackType: 'warning'
      });
      throw e;
    });
};

export const statusList = (dispatch, apiClient) => {
  dispatch({ type: 'ORDER_PENDING' });
  return apiClient
    .call({
      endpoint: 'order/statusList'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'ORDER_STATUS_LIST', statusList: res.data });
    })
    .catch(e => {
      dispatch({ type: 'ORDER_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get order Status List",
        snackType: 'warning'
      });
      throw e;
    });
};

export const ecommStatusList = (dispatch, apiClient) => {
  dispatch({ type: 'ORDER_PENDING' });
  return apiClient
    .call({
      endpoint: 'order/ecommStatusList'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'ORDER_ECOMM_STATUS_LIST', statusList: res.data });
    })
    .catch(e => {
      dispatch({ type: 'ORDER_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get order Status List",
        snackType: 'warning'
      });
      throw e;
    });
};

export const addTracking = (
  dispatch,
  apiClient,
  orderId,
  boxId,
  trackingCode
) => {
  return apiClient
    .call({
      endpoint: 'order/addTracking',
      data: { orderId, boxId, trackingCode }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't update order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const updateState = (
  dispatch,
  apiClient,
  orderId,
  boxId,
  state,
  reason
) => {
  return apiClient
    .call({
      endpoint: 'order/updateState',
      data: {
        orderId,
        boxId,
        state,
        reason
      }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Order update sent',
          snackType: 'warning'
        });
      }
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't update order",
        snackType: 'warning'
      });
      throw e;
    });
};

export const setAsPickedUp = (dispatch, apiClient, orders) => {
  return apiClient
    .call({
      endpoint: 'order/setAsPickedUp',
      data: { orders }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      } else {
        dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: 'Setting boxes as picked up',
          snackType: 'warning'
        });
      }
      return res;
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't update order",
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/orders.js